<template>
    <div class="page-table haberTanim mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.partner.tanimlama.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="partnerForm" :rules="rulesPartnerlar" ref="partnerForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.partner.tanimlama.partnerAdi")'
                                              prop="partnerAdi">:
                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                              v-model="partnerForm.partnerAdi"
                                              :placeholder='$t("src.views.apps.partner.tanimlama.partnerAdiPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.partner.tanimlama.adres")'
                                              prop="adres">:
                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                              v-model="partnerForm.adres" type="textarea"
                                              :placeholder='$t("src.views.apps.partner.tanimlama.adresPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.partner.tanimlama.harita")'
                                              prop="iframe">:
                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                              type="textarea"
                                              v-model="partnerForm.iframe"
                                              :placeholder='$t("src.views.apps.partner.tanimlama.haritaPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Resim'
                                              prop="image">:
                                    <el-upload
                                            action=""
                                            :auto-upload="false"
                                            :limit="1"
                                            :file-list="imageListMain"
                                            :on-change="imageUpload"
                                            :on-remove="imageRemove"
                                            accept=".jpg,.jpeg,.png"
                                            ref="upload"
                                            list-type="picture-card">
                                        <i slot="default" class="el-icon-plus"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1" :title='$t("src.views.apps.referans.guncelleme.durum")'>
                            <el-row>
                                <el-button size="mini" class="onayBtn"
                                           v-on:click="partnerGuncelle('partnerForm')"
                                           type="primary">
                                    {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                </el-button>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium" :title='$t("src.views.apps.partner.tanimlama.telefon")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="telefon">
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-model="partnerForm.telefon" v-mask="'+90(###)### ## ##'"
                                                      placeholder="+90(555)555 55 55"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium" :title='$t("src.views.apps.partner.tanimlama.mail")' name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="mail">
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)" type="email"
                                                      v-model="partnerForm.mail"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium" :title='$t("src.views.apps.partner.tanimlama.webSite")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="webSite">
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-model="partnerForm.link"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';

    let $ = JQuery;
    import draggable from "vuedraggable";
    import partnerService from '../../../WSProvider/PartnerService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataEstas = "";

    export default {
        name: "PartnerDuzenle",
        components: {
            draggable
        },
        data() {
            return {

                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                updateData: [],
                imageSil: false,

                //Tree
                visibleUstPartner: false,
                treeList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                // Form
                updatePartnerKodu: '',
                partnerDetayKlon: [],
                imageListMain: [],
                partnerForm: {
                    partnerAdi: "",
                    image: "",
                    imageBase: "",
                    adres: "",
                    iframe: "",
                    telefon: '',
                    mail: '',
                    link: '',
                    durum: "1",

                },
                rulesPartnerlar: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                    link: [{
                        required: true,
                        message: "Lütfen Link Giriniz",
                        trigger: 'blur'
                    }]
                },
            }
        },
        mounted() {
            this.updatePartnerKodu = this.$store.state.updateKodu;
            this.getPartnerDetay(this.updatePartnerKodu);
        },
        methods: {
            getPartnerDetay(updateKodu) {
                let self = this;
                partnerService.partnerDetay(updateKodu).then((response) => {
                    if (response.status === 200) {
                        for (var key in response.data) {
                            this.partnerForm[key] = response.data[key];
                            this.partnerDetayKlon = JSON.stringify(response.data);
                        }
                        if (response.data['resim']) {
                            $('.el-upload--picture-card').hide();
                            self.imageListMain.push({
                                name: response.data['resim'],
                                url: partnerService.imageUrlOrta + response.data['resim']
                            });
                        }
                    } else {
                        notification.Status(notification.status, this);
                    }
                })
            },
            partnerGuncelle(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        for (var key in JSON.parse(this.partnerDetayKlon)) {
                            if (key !== 'resim') {
                                if (JSON.parse(this.partnerDetayKlon)[key] !== this.partnerForm[key]) {
                                    if (this.partnerForm[key]) {
                                        var item = {
                                            type: key,
                                            value: this.partnerForm[key]
                                        };
                                        this.updateData.push(item);
                                    }
                                }
                            }
                        }
                        partnerService.partnerGuncelle(this.updatePartnerKodu, this.updateData).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Partner başarıyla güncellendi.');
                                this.resetForm(formName);
                            }
                            if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir partner zaten mevcut');

                            } else {
                                notification.Status(notification.status, this)
                            }
                        })
                    }
                })
            },
            resetForm(formName) {
                this.imageListMain = [];
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.partnerForm.partnerTuru = '0';
                this.visibleUstPartner = false;
                this.partnerForm.link = null;
                this.linkVisible = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "PartnerDuzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "PartnerDuzenle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.partnerForm.partnerAdi) {
                        var imgName = randomText(7) + '-' + linkTemizle(this.partnerForm.partnerAdi) + ".png";
                    } else {
                        imgName = randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }
                    this.partnerForm.image = imgName;
                    this.sumResimFonk(file,imgName)
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('partner', imgname, data).then((response) => {
                            if (response.status === 200) {
                                updateList(this, 'resim', 1, imgname);
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageRemove(file) {
                $('.el-upload--picture-card').show();
                this.imageSil = true;
            },
        }

    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }

    function updateList(self, type, durum, name) {
        var item = {
            type: type,
            value: "partner-"+name
        };
        self.updateData.push(item);
    }
</script>


<style scoped>
    .el-tag + .el-tag {
        margin-left: 10px;
    }


    .yanForm .card {
        margin-top: 10px;
    }

</style>